var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer_copy ta-c"},[_vm._v(" © 2025 "),_c('a',{attrs:{"href":"http://crygrp.cn/"}},[_vm._v("Crygrp")]),_vm._v(" All Rights Reserved. ")])
}]

export { render, staticRenderFns }